import { Inject } from 'inversify-props'
import { EventoDeWebhookDisponivel, Webhook } from '@/models'
import type { WebhookServiceAdapter } from './adapter/WebhookServiceAdapter'

export class FindWebhookUseCase {
	@Inject('WebhookServiceAdapter')
	private webhookServiceAdapter!: WebhookServiceAdapter

	listar = async (): Promise<Webhook[]> =>
		await this.webhookServiceAdapter.listar()

	get = async (id: string): Promise<Webhook> =>
		await this.webhookServiceAdapter.get(id)

	listarEventosDisponiveis = async (): Promise<EventoDeWebhookDisponivel[]> =>
		await this.webhookServiceAdapter.listarEventosDisponiveis()
}
